import { createRouter, createWebHistory } from 'vue-router';
import { useAuthStore } from '@/store/auth.module';
import Home from '@/views/Home.vue';
import Login from '@/views/Login.vue';
import OauthRedirect from '@/views/OauthRedirect.vue';
import ManagerProfile from '@/views/ManagerProfile.vue';
import MegaLeague from '@/views/MegaLeague.vue';
import MastersLiga from '@/views/MastersLiga.vue';
import Admin from '@/views/Admin.vue';
import PrivacyPolicy from '@/views/PrivacyPolicy.vue';
import ComingSoon from "@/views/ComingSoon.vue";


const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      layout: 'public',
    },
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      layout: 'public',
    },
  },
  {
    path: '/coming-soon',
    name: 'ComingSoon',
    component: ComingSoon,
    meta: {
      layout: 'public',
    },
  },
  {
    path: '/privacy-policy',
    name: 'PrivacyPolicy',
    component: PrivacyPolicy,
    meta: {
      layout: 'public',
    },
  },
  {
    path: '/oauth/redirect',
    name: 'OauthRedirect',
    component: OauthRedirect,
    meta: {
      layout: 'public',
    },
  },
  {
    path: '/manager/:userSlug',
    name: 'ManagerProfile',
    component: ManagerProfile,
    meta: {
      layout: 'private',
    },
  },
  {
    path: '/mega-league',
    name: 'MegaLeague',
    component: MegaLeague,
    meta: {
      layout: 'private',
    },
  },
  {
    path: '/masters-liga',
    name: 'MastersLiga',
    component: MastersLiga,
    meta: {
      layout: 'private',
      requiresAdmin: true,
    },
  },
  {
    path: '/admin',
    name: 'Admin',
    component: Admin,
    meta: {
      layout: 'private',
      requiresAdmin: true,
    },
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/',
  },
];

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  const authStore = useAuthStore();
  const publicRoutes = routes
    .filter((route) => route.meta?.layout === 'public')
    .map((route) => route.path);

  const isLoggedIn = authStore.isLoggedIn;

  if (!publicRoutes.includes(to.path) && !isLoggedIn) {
    return next('/');
  }

  if (publicRoutes.includes(to.path) && isLoggedIn) {
    return next('/mega-league');
  }

  if (to.meta.requiresAdmin && !authStore.hasRoleAdmin) {
    return next('/');
  }

  next();
});

export default router;
